"use client";

import { useIsMobile } from "@/hooks/use-mobile";
import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";
type ToasterProps = React.ComponentProps<typeof Sonner>;
const Toaster = ({
  ...props
}: ToasterProps) => {
  const {
    theme = "system"
  } = useTheme();
  const isMobile = useIsMobile();
  return <Sonner theme={theme as ToasterProps["theme"]} position={isMobile ? "top-center" : "bottom-right"} className="" // i removed "group", "toaster" and "toast" classes
  toastOptions={{
    classNames: {
      toast: "group bg-blue-500 text-light rounded-xl border-transparent shadow-lg",
      description: "text-muted",
      actionButton: "bg-primary text-primary-foreground",
      cancelButton: "bg-muted text-muted-foreground"
    }
  }} {...props} data-sentry-element="Sonner" data-sentry-component="Toaster" data-sentry-source-file="sonner.tsx" />;
};
export { Toaster };

// Recycled

// 08 May 2025

// "group bg-light/10 backdrop-blur-xl text-light rounded-xl border-transparent shadow-lg"